import React from 'react'
import { compact } from 'lodash'

import { InputWrapper } from '../InputWrapper'
import css from './style.scss'

/**
 * Controlled input component. Is compatible with redux-form Field
 */
const Input = (props) => {
  const classNames = [
    css.input,
    props.globalError ? css.globalError : null,
    props.className
  ]

  const style = {}

  if (props.maxInputWidth) {
    style.maxWidth = props.maxInputWidth
  }

  // Default to the field name so <Label htmlFor='name'> associates without passing an id
  const id = props.id || (props.input && props.input.name)
  const errorId = id && !props.hideMeta ? `${id}-error` : undefined
  const meta = props.meta || {}
  const hasError = meta.error && !meta.active && (meta.dirty || meta.touched)

  return (
    <InputWrapper hideMeta={!!props.hideMeta} {...meta} errorId={errorId}>
      <input
        id={id}
        style={style}
        className={compact(classNames).join(' ')}
        {...props.input}
        type={props.type}
        maxLength={props.maxLength}
        autoComplete={props.disableAutocomplete ? 'off' : (props.autoComplete || 'on')}
        aria-required={props['aria-required']}
        // for type='number'
        max={props.max}
        min={props.min}
        disabled={props.disabled}
        placeholder={props.placeholder}
        aria-describedby={errorId}
        aria-invalid={hasError || undefined}
        onWheel={props.onWheel || (props.type === 'number' ? e => e.target.blur() : undefined)}
      />
      {props.afterControl}
    </InputWrapper>
  )
}

Input.propTypes = {
  id: React.PropTypes.string,
  input: React.PropTypes.object,
  meta: React.PropTypes.object,
  type: React.PropTypes.string,
  disabled: React.PropTypes.bool,
  maxLength: React.PropTypes.number,
  min: React.PropTypes.number,
  max: React.PropTypes.number,
  maxInputWidth: React.PropTypes.oneOfType([
    React.PropTypes.number,
    React.PropTypes.string
  ]),
  disableAutocomplete: React.PropTypes.bool,
  /* Specific autocomplete token, e.g. 'email' or 'given-name' (WCAG 1.3.5). Defaults to 'on' */
  autoComplete: React.PropTypes.string,
  'aria-required': React.PropTypes.bool,
  globalError: React.PropTypes.string,
  /* Extra content rendered inside InputWrapper, above the reserved error text area */
  afterControl: React.PropTypes.node
}

Input.defaultProps = {
  type: 'text',
  disableAutoComplete: false,
  disabled: false,
  placeholder: null
}

export default Input
